import { LoginOption } from '../../data-types/login/loginInterfaces';
import { store } from '../store';
import { SET_FROM_APP_FLAG, SET_IS_LOGGING_IN_FROM_REDIRECT, SET_LOGIN_OPTIONS } from '../types/loginTypes';

export const setLoginOptions = (meta: LoginOption[]) => {
  store.dispatch({
    meta,
    type: SET_LOGIN_OPTIONS,
  });
};

export const setIsLoggingInFromRedirect = (meta: boolean) => {
  store.dispatch({
    meta,
    type: SET_IS_LOGGING_IN_FROM_REDIRECT,
  });
};

export const setFromAppFlag = (flag: boolean) => {
  store.dispatch({
    type: SET_FROM_APP_FLAG,
    meta: flag,
  });
};
